import {api} from "@ergeon/erg-utils-js";

import auth from "auth";

export const createApi = (config={}) => api.createApi(
  `${process.env.API_URL}/api/fieldapp`,
  () => auth().getAuthHeader(),
  config
);

export default () => createApi();



/** WEBPACK FOOTER **
 ** ./src/app/api.js
 **/